import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { HelperService } from "../helperService";
@Injectable({
    providedIn: 'root'
})
export class APIBlockedAttentionSchedules {
    ApiURL: string = "";
    constructor(private http: HttpClient, private helperService: HelperService) {
        this.ApiURL = environment.blockedAttentionURL + 'BlockedAttentionSchedules/';
    }
    public getByworkshopId(workshopId: string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.get(this.ApiURL +'bydealer/'+ encodeURIComponent(workshopId),requestOptions);
    }
    public get(workshopId: string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        if (workshopId!== null && workshopId!== undefined) {
            return this.http.get(this.ApiURL + encodeURIComponent(workshopId),requestOptions);
       } else {
           return this.http.get(this.ApiURL,requestOptions);
        }
    }

    public post(data): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.post<any>(this.ApiURL, data,requestOptions)
    }

    public put(id): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.put<any>(this.ApiURL, id,requestOptions)
    }

    public delete(id: number):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        let apiURL = `${this.ApiURL}${id}`;
        return this.http.delete(apiURL,requestOptions)
    }
}